var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepStyleVariedGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.806,
    height: 116.65,
    viewBox: "0 0 58.806 116.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4972",
    "data-name": "Group 4972",
    transform: "translate(-286 -188.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8246",
    "data-name": "Path 8246",
    d: "M89.937,144.663c.032-.231.84.184,1.341.466a.059.059,0,0,0,.071-.094c-.689-.694-2.276-2.3-2.577-2.7-.387-.51,1.534-.361,1.421-.376.061-.448,1.167-.183,1.263-.055.428-.626,1.009.138,1.5-.137,1.156.6,2.186,2.623,2.591,3.5l.012-.008a17.992,17.992,0,0,0,2.391,3.713,33.425,33.425,0,0,1-2.708,2.409l-1.855-3.241a2.887,2.887,0,0,0-1.193-1.158,6.067,6.067,0,0,1-2.261-2.322",
    transform: "translate(384.528 51.896) rotate(48)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    d: "M96.737,144.664c-.032-.231-.84.184-1.341.466a.059.059,0,0,1-.071-.094c.689-.694,2.276-2.3,2.577-2.7.387-.51-1.534-.361-1.421-.376-.061-.448-1.167-.183-1.263-.055-.428-.626-1.009.138-1.5-.137-1.156.6-2.186,2.623-2.591,3.5l-.012-.008a18,18,0,0,1-2.391,3.713,33.427,33.427,0,0,0,2.708,2.41l1.855-3.241a2.887,2.887,0,0,1,1.193-1.158,6.067,6.067,0,0,0,2.261-2.322",
    transform: "translate(206.182 60.781)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7004",
    "data-name": "Path 7004",
    d: "M145.7,592.274l-.507,6.419,15.542-.169-.676-7.94Z",
    transform: "translate(155.376 -343.107)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    d: "M185.935,27.326l-1.764-.66A122.958,122.958,0,0,0,159.6,20.273a2.094,2.094,0,0,1-1.61-2.894l.767-1.793A44.951,44.951,0,0,0,162.2,1.913,2.094,2.094,0,0,1,165.035.145l.313.12a122.961,122.961,0,0,0,24.46,6.614l1.521.247a2.094,2.094,0,0,1,1.582,2.91l-.5,1.144a44.953,44.953,0,0,0-3.569,13.537l-.087.86a2.094,2.094,0,0,1-2.817,1.749",
    transform: "translate(144.019 188.213)",
    fill: "#ffe0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    d: "M156.487,174.816s7.433,1.014,7.433-6.419-6.757-7.6-11.994-8.109-5.068-7.433-9.122-7.433-11.517,6.778-6.449,12.352,7.294,1.838,9.659,4.034,2.064,5.024,5.086,5.384a31.57,31.57,0,0,0,5.387.191",
    transform: "translate(164.86 50.699)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    d: "M53.857,224.333s-3.885-3.885-6.251-4.392-12.67-2.365-12.67-2.365,3.886-6.926,3.886-7.433-3.379-2.872-4.392-2.365-6.588,9.46-5.913,12.163,12.5,7.94,12.5,7.94a69.754,69.754,0,0,1,.507,9.46c-.169,4.054-3.379,10.474-2.872,11.319s16.724,3.21,17.907,1.52.338-7.6,1.52-8.278,6.251-3.548,4.223-7.771c0,0,13.515-.169,15.2-2.2s2.2-11.15,2.2-11.15-5.068-1.52-5.575-.338-2.027,7.1-2.027,7.1-13.178-2.575-14.444-2.048-3.8-1.162-3.8-1.162",
    transform: "translate(260.395 1.352)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7008",
    "data-name": "Path 7008",
    d: "M269.726,337.581a8.008,8.008,0,0,1-2.568,2.346,1.236,1.236,0,0,0-.716,1.447,4.163,4.163,0,0,0,3.762,3.265c2.365,0,3.716-3.379,3.716-3.379Z",
    transform: "translate(46.33 -115.49)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    d: "M5.7,989.077l8.981-6.635-3.078-4.13-6.969,7.459a3.963,3.963,0,0,1-1.97,1.159,5.988,5.988,0,0,0-2.1.913,1.183,1.183,0,0,0-.428,1.532l4.436,7.211c.256.391.961.2,1.083-.3.179-.728-.182-1.761-.226-3.573a11.5,11.5,0,0,0-.251-2.209,1.393,1.393,0,0,1,.523-1.428",
    transform: "translate(286 -691.928)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    d: "M309.428,966.747l3.909-10.46-4.833-1.783-1.774,10.053a3.965,3.965,0,0,1-1.019,2.046,5.987,5.987,0,0,0-1.262,1.91,1.183,1.183,0,0,0,.477,1.518l7.651,3.625c.428.188.913-.359.745-.842-.246-.708-1.113-1.377-2.138-2.871a11.494,11.494,0,0,0-1.415-1.715,1.393,1.393,0,0,1-.34-1.482",
    transform: "translate(12.185 -670.512)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7012",
    "data-name": "Path 7012",
    d: "M50.034,642c-.761,3.044-3.425,5.708.19,10.654s5.708,10.845,5.708,11.8-15.221,13.889-15.221,16.172,1.9,5.327,3.044,4.757,20.358-13.318,21.119-15.221-.19-14.269-.19-14.269,7.23,2.283,7.23,4.756-3.615,15.031-3.044,17.5,4.947,3.615,5.137,3.044,10.655-18.265,9.894-22.07-13.87-16.733-15.411-17.5c-2.283-1.142-17.694-2.664-18.455.381",
    transform: "translate(249.374 -387.75)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7013",
    "data-name": "Path 7013",
    d: "M294.711,291.386a5.739,5.739,0,0,0,.381,5.139,4.259,4.259,0,0,0,3.825,2.1c4.392,0,6.553-7.331,4.357-9.02-1.916-1.474-6.747-2.805-8.562,1.779",
    transform: "translate(21.249 -71.084)",
    fill: "#ff9976"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStyleVariedGreen);
export default __webpack_public_path__ + "static/media/sleepStyleVariedGreen.5cc034abe8e902b947118d5ae0d90934.svg";
export { ForwardRef as ReactComponent };